import { IEditInitialState } from '../types'

export const getSlideOrder = (state: IEditInitialState): number => {
  return (
    state.activeDeck.data?.deckData?.data.slides.find(
      ({ slideId }) => slideId === state.activeSlideID,
    )?.orderIndex || 1
  )
}
